export default "__VITE_ASSET__Cucoc84a__"